<template>
  <div v-loading="element_loading" element-loading-text="拼命加载中......" element-loading-spinner="el-icon-loading"
    element-loading-background="rgba(0, 0, 0, 0.8)" class="inline-oil">
    <!-- <h5>油卡余额不足</h5> -->


    <table class="dataintable">

      <tr class="tab_header">
        <td>序号</td>
        <td class="short0 left">车牌</td>
        <td class="short0 left">名称</td>
        <td class="short0">日期</td>
        <td class="short0">类型</td>
        <td class="short0">修改人</td>
        <td class="long1_4">更新时间</td>
        <td >操作</td>
      </tr>
      <tr v-for="(item, index) in list_lose" :key="index">
        <td>{{ item.row_num }}</td>
        <td class="short0 left">{{item.car_no}}</td>
        <td class="short0">{{ item.lose_name }}</td>
        <td class="short0">{{ item.lose_date }}</td>
        <td class="short0">{{ item.lose_flag }}</td>
        <td class="short0">{{item.u_name}}</td>
        <td class="long1_4">{{item.sys_date}}</td>
        <td ><span class="hulue-btn" v-show="item.u_flag=='2'" @click="fun_isNot(item)">取消</span></td>
      </tr>
    </table>
  </div>
</template>

<script>
  import api from '@/utils/type.js'

  import {
    Sel_page_and_length,
    Method_EasyAdd
  } from '@/utils/loadhttpdata.js';

  export default {
    name: "carlose",
    data() {
      return {
        element_loading: false,

        list_lose: []




      };
    },
    created: function() {
      // console.log('油卡 组件 创建');
      // this.loaddata();
    },
    mounted: function() {
      // console.log('油卡 组件 mounted');
      this.loaddata();
    },
    // activated: function() {
    //   console.log('油卡 组件激活时调用 激活');

    // },
    methods: {
      loaddata: function() {
        this.element_loading = true;
        this.list_lose = [];

        let r = (Math.random() + '').substring(0, 8);

        this.$post(
          api.http_method, Sel_page_and_length('exp_warninglose', 1, 999)
        ).then(res => {
          this.element_loading = false;
          res = JSON.parse(res);
          if (res.length > 0) {

            let t = res[0];
            for (let i = 0; i < t.length; i++) {
              let o = {};

              o = t[i];
              o.row_num = i + 1;
              this.list_lose.push(o);
            }
          }


        });
      },
      fun_isNot:function(item){
        console.log(item);
        this.element_loading = true;

        this.$post(
          api.http_method, Method_EasyAdd('data_exp_carbaoxian',item.car_no,item.lose_name,'1',item.lose_date)
        ).then(res => {
          this.element_loading = false;
          res = JSON.parse(res);
          // console.log(res);
          if (res.data.status == 1) {
            this.$message({
              message: item.car_no+':'+res.data.msg,
              type: 'success'
            });

            this.loaddata();

          } else {
            this.$message({
              message: res.data.msg,
              type: 'warning'
            });
          }
        });
      }
    }


  }
</script>

<style scoped="scoped">
  .inline-oil {
    display: inline-block;
    min-height: calc(100vh - 120px);
    max-height: calc(100vh - 120px);
    overflow: auto;
    vertical-align: top;
  }

  .tab_header td {
    /* 纵向渐变 */
    /* Safari 5.1 - 6.0 */
    background: -webkit-linear-gradient(#3da5d9, #a2d2ff);
    /* Opera 11.1 - 12.0 */
    background: -o-linear-gradient(#3da5d9, #a2d2ff);
    /* Firefox 3.6 - 15 */
    background: -moz-linear-gradient(#3da5d9, #a2d2ff);
    /* 标准的语法（必须放在最后） */
    background: linear-gradient(#3da5d9, #a2d2ff);
    text-align: center;
    color: #000000;
    font-size: 14px;
    font-weight: 400;
  }



  .hulue-btn {
    display: inline-block;
    /* border: 1px solid black; */
    border-radius: 5px;
    background: #00ff00;
    text-align: center;
    padding: 2px 2px 2px 2px;
    /* font-size: 16px; */
    margin-left: 2px;
    margin-right: 2px;
  }

  .hulue-btn:hover {
    cursor: pointer;

    background: #e5e5e5;
    /* font-size: 16px; */
  }
</style>
